/**
 * Voucher list item from marketing backend (published list or campaign vouchers).
 * `voucherSchema.expiryEndDatetime` — when absent, treat as open-ended (still selectable).
 */
export function isVoucherListItemNotExpired(item) {
  if (!item || typeof item !== 'object') return false;
  const vs = item.voucherSchema || {};
  const end = vs.expiryEndDatetime;
  if (end == null || end === '') return true;
  const endMs = new Date(end).getTime();
  if (!Number.isFinite(endMs)) return true;
  return endMs >= Date.now();
}

/** API list row or nested voucherSchema with status / isActive. */
export function isVoucherSchemaActive(item) {
  if (!item || typeof item !== 'object') return false;
  const vs = item.voucherSchema || {};
  const status = vs.status ?? item.status;
  if (typeof status === 'string' && status.trim().toLowerCase() === 'inactive') {
    return false;
  }
  if (vs.isActive === false || item.isActive === false) {
    return false;
  }
  return true;
}

/** Saved marketing-page voucher row (flat shape from fullConfig.content.vouchers). */
export function isMarketingStoredVoucherActive(voucher) {
  if (!voucher || typeof voucher !== 'object') return false;
  const status = voucher.status || voucher.voucherSchema?.status;
  if (typeof status === 'string' && status.trim().toLowerCase() === 'inactive') {
    return false;
  }
  if (voucher.isActive === false || voucher.voucherSchema?.isActive === false) {
    return false;
  }
  return true;
}

export function isVoucherListItemDisplayable(item) {
  return isVoucherListItemNotExpired(item) && isVoucherSchemaActive(item);
}

/** Transformed modal row keeps `_original` API item; otherwise treat `row` as the API item. */
export function isMarketingOpsVoucherRowNotExpired(row) {
  const item = row?._original || row;
  return isVoucherListItemNotExpired(item);
}

export function isMarketingOpsVoucherRowDisplayable(row) {
  const item = row?._original || row;
  return isVoucherListItemDisplayable(item);
}
